<div class="no-views__container">
    <div class="d-flex align-items-center justify-content-center flex-column full-height">
        <div class="icon__container">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="137.68335832083957 67.44 124.73763118440779 165"
                height="50">
                <g transform="translate(200, 150)">
                    <rect ry="8" rx="8" stroke-width="3" stroke="var(--m3-sys-primary)" fill="var(--m3-sys-surface)"
                        height="160" width="120" y="-80" x="-60" />
                    <line stroke-opacity="0.3" stroke-width="2.5" stroke="var(--m3-sys-primary)" y2="-50" x2="40"
                        y1="-50" x1="-40" />
                    <line stroke-opacity="0.3" stroke-width="2.5" stroke="var(--m3-sys-primary)" y2="-30" x2="25"
                        y1="-30" x1="-40" />
                    <line stroke-opacity="0.3" stroke-width="2.5" stroke="var(--m3-sys-primary)" y2="-10" x2="40"
                        y1="-10" x1="-40" />
                    <line stroke-opacity="0.3" stroke-width="2.5" stroke="var(--m3-sys-primary)" y2="10" x2="20" y1="10"
                        x1="-40" />
                    <rect ry="5" rx="5" fill="var(--m3-sys-primary)" height="38" width="45" y="30" x="-22.5" />
                    <path stroke-linecap="round" stroke-width="4.5" stroke="var(--m3-sys-primary)" fill="none"
                        d="M -10,30 L -10,15 Q 0,0 10,15 L 10,30" />
                </g>
            </svg>
        </div>
        <h4 class="mb-2">
            {{ "gridFilter.noViewsAvailable" | translate }}
        </h4>
        @if(permissions.CreateTableView | hasPermission) {
        <button mat-button color="primary" (click)="createViewClicked.emit(true)">
            <icon name="add" class="button__icon"></icon>
            {{ "gridFilter.createView" | translate }}
        </button>
        }
        @else {
        <p class="text-gray mb-0">
            {{ "gridFilter.contactAdminToShareView" | translate }}
        </p>
        }
    </div>
</div>